import * as Sentry from '@sentry/react';

const isStaging = window.location.hostname.startsWith('staging.');

Sentry.init({
  dsn: import.meta.env['VITE_SENTRY_DSN'] as string | undefined,
  environment: import.meta.env.DEV ? 'development' : isStaging ? 'staging' : 'production',
  enabled: !!import.meta.env['VITE_SENTRY_DSN'],
  tracesSampleRate: import.meta.env.PROD ? 0.2 : 1.0,
  integrations: [Sentry.browserTracingIntegration()],
  tracePropagationTargets: ['localhost', /^https:\/\/(staging\.)?seasnag\.com\/api/],
});
